import BaseModelInstance from './base.model'
import { LeadSource as ModelDefinition } from './model-definitions'

class LeadSource extends BaseModelInstance {
  afterSet = (key, value) => {}

  constructor(attribs) {
    super(ModelDefinition, attribs)
  }
}

export default LeadSource
